module.exports = __webpack_public_path__ + "img/jtz-3.4601ebe3.png";